import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NewRegistrationService {
  url = GlobalVariable.BASE_API_URL;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });

  constructor(
    private http: HttpClient
  ) { }

  public ValidateEmailDemre(rut: string, dv: string, esCent: boolean, esPasaporte: boolean = false) {
    debugger;
    let httpParams = new HttpParams()
      .set('rut', rut)
      .set('dv', dv)
      .set('esPasaporte', String(esPasaporte))
      .set('esCentralizado', String(esCent))
    return this.http.post(`${this.url}newRegistration/validateEmailDemre`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }

  public ValidarGuid(guid: string): any {
    let httpParams = new HttpParams()
      .set('guid', guid)
    return this.http.post(`${this.url}newRegistration/Validar`,
      null,
      {
        headers: this.headersc,
        params: httpParams
      });
  }
}
